import dialogInstancePropertyCreator
  from '@/components/global_components/dialogs/global-dialogs/dialogInstancePropertyCreator';
import GlobalConfirmationDialog from '@/components/global_components/dialogs/global-dialogs/GlobalConfirmationDialogComponent';
import dateFormatter from '@/services/formatter_services/date-formatter';
import cloneDeep from "lodash/cloneDeep";
import { getComponentByDescriptionType } from '@/components/global_components/dialogs/global-dialogs/services/confirmation-type-service'

export class GlobalConfirmationErrorHandler {

  constructor(errorData) {
    this.errorData = errorData;
  }

  async execute(finishedCallback, currentConfirmations, confirmationCallbackSetter, customDialogComponent=null) {
    try {
      let selectedOption = await this.openConfirmationDialog(this.errorData, customDialogComponent);
      this.updateConfirmations(currentConfirmations, undefined, selectedOption)
        .invokeConfirmationSetter(confirmationCallbackSetter)
        .invokeFinishedCallback(finishedCallback);
    } catch (e) {
      this.resetConfirmations(confirmationCallbackSetter);
    }
  }

  openConfirmationDialog(confirmation, customDialogComponent=null) {
    const dialogComponent = customDialogComponent ?? getComponentByDescriptionType(confirmation.descriptionType);
    const confirmationDialog = dialogInstancePropertyCreator(GlobalConfirmationDialog, {
      component: dialogComponent,
      confirmation: confirmation,
    });
    return confirmationDialog.open();
  }

  updateConfirmations(currentConfirmations = [], confirmMessage = this.errorData.confirmMessage, selectedOption) {
    const clonedConfirmations = cloneDeep(currentConfirmations);

    clonedConfirmations.push({
      message: confirmMessage,
      confirmedAt: dateFormatter.getLocalDateTimeStringNow(),
      selectedOption: selectedOption
    });

    this.updatedConfirmations = clonedConfirmations;
    return this;
  }

  invokeConfirmationSetter(confirmationCallbackSetter, newConfirmations = this.updatedConfirmations) {
    if (confirmationCallbackSetter != undefined) {
      confirmationCallbackSetter(newConfirmations);
    }
    return this;
  }

  invokeFinishedCallback(finishedCallback, updatedConfirmations = this.updatedConfirmations) {
    if (finishedCallback != undefined) {
      finishedCallback(updatedConfirmations);
    }
    return this;
  }

  resetConfirmations(confirmationCallbackSetter) {
    if (confirmationCallbackSetter != undefined) {
      confirmationCallbackSetter([]);
    }
    return this;
  }
}
